import React from 'react'
import PropTypes from 'prop-types'
import { Router, Switch, Route } from 'react-router-dom'
import configment from '@adc/configment'
import App from './containers/auctionApp'
import history from './history'

/**
 * NOTE: To all future people reading this. I know that query params would be a better choice here. When I refactored
 * this the app had been stable for 5 years and people were used to this existing url pattern and we were focused on
 * shipping another project to replace all the data reads here.
 *
 * A good improvement here would be to get rid of the router completely and use query params like we do for other
 * apps. The event app this calendar app links to uses query params instead of a special route pattern, for example.
 * Also not that with the way this was constructed not all filters have matching routes. The paths here were from an
 * even older app that business then targeted so we keep for backwards compat.
 */
const getPath = () =>
  [configment.get('URL_BASE_PREFIX'), '/:product_type?', '/:state?'].join('')

/**
 * Route definitions shared between the client (BrowserRouter) and the server
 * (StaticRouter). react-router v5 injects `match` rather than v3's flat
 * `params` prop, so we adapt it here to keep the downstream `params` contract
 * unchanged.
 */
export const AppRoutes = ({ ssrHints }) => (
  <Switch>
    <Route
      path={getPath()}
      render={({ match }) => <App params={match.params} ssrHints={ssrHints} />}
    />
  </Switch>
)

const AppRouter = ({ ssrHints }) => (
  <Router history={history}>
    <AppRoutes ssrHints={ssrHints} />
  </Router>
)

AppRoutes.propTypes = {
  ssrHints: PropTypes.object,
}

AppRouter.propTypes = {
  ssrHints: PropTypes.object,
}

export default AppRouter
